export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const nameRegex = /^[A-Z-Α-Ω-ΆΈΊΌΎΏ][A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώ]/;

export const nameRegexGreekOnly = /^[Α-Ω-ΆΈΊΌΎΏ ][A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώ ]/;

export const birthDateRegex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;

export const lettersOnly = /^([^0-9]*)$/;

export const streetNumber = /(^([0-9]{1,3}))(([a-zA-z]?)\b)/;

export const numbersOnly = /^[0-9]*$/;

export const firstCapitalOnly = /^[A-Z-Α-Ω-Ά-Ώ][a-z-α-ω-ά-ώ]+$/;

export const firstCapitalOnlyAndGreekOnly = /^[Α-Ω-Ά-Ώ][α-ω-ά-ώ]+$/;

export const email  = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const streetRegex = /^[Α-Ω-Ά-Ώ-α-ω-ά-ώ0-9_]/;